const locale = {
    placeholder: 'Aukeratu ordua',
    rangePlaceholder: ['Hasiera ordua', 'Amaiera ordua'],
};
export default locale;
